import React from 'react';
import { Box, Chip, Button, Typography } from '@mui/material';

const ActiveFiltersBar = ({ filters, onClearFilter, onClearAll }) => {
  const activeFilters = [];

  if (filters.classification) {
    const classificationLabels = {
      'HIGH_RISK_CREEP': 'Critical Risk',
      'MODERATE_CREEP': 'Moderate Risk',
      'LOW_RISK': 'Low Risk',
      'APPROPRIATE_ACCESS': 'Appropriate Access'
    };
    activeFilters.push({
      key: 'classification',
      label: classificationLabels[filters.classification] || filters.classification,
      value: filters.classification
    });
  }

  if (filters.minRiskScore) {
    const scoreLabels = {
      8: 'Critical (8+)',
      6: 'High Risk (6+)',
      4: 'Moderate (4+)',
      2: 'Low (2+)'
    };
    activeFilters.push({
      key: 'minRiskScore',
      label: scoreLabels[filters.minRiskScore] || `Risk Score ${filters.minRiskScore}+`,
      value: filters.minRiskScore
    });
  }

  if (filters.department && filters.department !== 'all') {
    activeFilters.push({
      key: 'department',
      label: `Department: ${filters.department}`,
      value: filters.department
    });
  }

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
        py: 1.5,
        px: 2,
        bgcolor: 'info.main',
        borderRadius: 1,
        opacity: 0.9,
        flexWrap: 'wrap',
        gap: 1
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
        <Typography variant="body2" sx={{ mr: 1, fontWeight: 'bold', color: 'info.contrastText' }}>
          Active Filters:
        </Typography>
        {activeFilters.map((filter) => (
          <Chip
            key={filter.key}
            label={filter.label}
            color="primary"
            size="small"
            onDelete={() => onClearFilter(filter.key)}
          />
        ))}
      </Box>
      <Button
        variant="outlined"
        size="small"
        onClick={onClearAll}
        sx={{ color: 'info.contrastText', borderColor: 'info.contrastText' }}
      >
        Clear All
      </Button>
    </Box>
  );
};

export default ActiveFiltersBar;
